var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pg-icon-div-wapper",class:_vm.iconDivClass},[_c('div',{staticClass:"pg-icon-div-icon"},[_c('Icon',{style:('font-size:' + _vm.iconFontSize),attrs:{"type":_vm.icon,"custom":_vm.icon}})],1),_vm._v(" "),_c('div',{staticClass:"slotClass",style:(`${_vm.otherStyle}max-width:${_vm.maxWidth}`)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }